// TODO: divide this module to investment and investmentList
export default function () {
  return {
    createModel: {},
    stepModels: {},
    investmentData: {},
    investmentDataLoading: false,
    investmentDataLoaded: false,
    investmentList: [],
    investmentListLoading: false,
    investmentListLoaded: false,
    reInitiateTransactionInvestmentListItemLoading: false,
    selectedProfileId: null,
    investmentSingleData: {},
    investmentSingleDataLoading: false,
    investmentListCompletedSuccessful: [],
    investmentListCompletedSuccessfulLoaded: false,
    investmentListExited: [],
    investmentListExitedLoading: false,
    investmentListExitedLoaded: false,
  };
}
